import { isError } from "lodash";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import {
  useCrudEditContext,
  useDynamicFormsTranslate,
  usePageContext,
} from "@ryde/redux";
import {
  errors,
  ICustomField,
  IExtendableDto,
  isPasswordAuthTypeSelector,
  Log,
  simpleResultErrorInfo,
} from "@ryde/shared";

import { MuiButton } from "../../controls";
import { getResetPasswordAPIFunction } from "./models";

export const ResetPasswordButtonTemplate: FC<ICustomField> = ({
  name,
  formLabel,
}) => {
  const {
    data: { isEdit, dto },
  } = useCrudEditContext<IExtendableDto>();
  const { t } = useTranslation();
  const { entity } = usePageContext();
  const { formLabelTranslated } = useDynamicFormsTranslate({
    name,
    fallbackText: formLabel,
  });
  const isPasswordAuthType = useRecoilValue(isPasswordAuthTypeSelector);

  const onClickHandler = useEvent(async () => {
    if (!dto) {
      return;
    }

    try {
      const apiFunction = getResetPasswordAPIFunction(entity);
      const result = await apiFunction(dto.id);

      if (result?.success) {
        Log.successAndToast(t(`${entity}.passwordResetEmailHasBeenSent`));
      } else if (result) {
        Log.errorAndToast(simpleResultErrorInfo(result, t));
      } else {
        Log.errorAndToast(t(errors.common.unknownError));
      }
    } catch (error) {
      if (isError(error)) {
        Log.errorAndToast(error.message);
      } else {
        Log.errorAndToast(t(errors.common.unknownError));
      }
    }
  });

  if (!isEdit) {
    return;
  }

  if (!isPasswordAuthType) {
    return null;
  }

  return <MuiButton onClick={onClickHandler}>{formLabelTranslated}</MuiButton>;
};
